import { createDecorator } from '../../instantiation/common/instantiation.js';
const INotificationService = ( createDecorator('notificationService'));
export { INotificationService };
